import CategoryField from './category_field'
import { Alert } from '@cinesend/ui-kit'
import { getSectionFieldLabel, mapAssignedCategory } from './category_helpers'

const AssignedCategories = ({
  availableCategories,
  categories,
  assetID,
  cycleID,
  issue,
  assetType,
  isWarningSlate,
  availableWarningSlates,
  langID,
}) => {
  const showCategories = !['ad', 'episode', 'track'].includes(assetType)
  const warningSlateCategories = categories.filter((cat) => cat.type === 'warning-slates')

  const getCategoryValues = (category) =>
    category.child_categories.map((item) => mapAssignedCategory(item, categories, langID)).filter(Boolean)

  return (
    <div className='flex flex-col gap-4'>
      {issue && (
        <Alert tone='error' size='sm'>
          {issue?.description}
        </Alert>
      )}
      {showCategories &&
        availableCategories
          .filter((section) => (section.child_categories ?? []).length > 0)
          .map((section) => (
            <CategoryField
              title={getSectionFieldLabel(section, langID)}
              options={section.child_categories}
              value={getCategoryValues(section)}
              key={section.id}
              assetID={assetID}
              cycleID={cycleID}
              langID={langID}
              type='assets'
            />
          ))}
      {assetType === 'ad' && isWarningSlate && (
        <CategoryField
          title='Warning Slate Groups'
          options={availableWarningSlates}
          value={warningSlateCategories.map((category) => mapAssignedCategory(category, categories, langID))}
          key='warning-slates'
          assetID={assetID}
          cycleID={cycleID}
          langID={langID}
          type='warning-slates'
          isMulti={true}
        />
      )}
      {assetType === 'featured-content' && (
        <CategoryField
          title='Section'
          options={availableCategories}
          value={categories.map((category) => mapAssignedCategory(category, categories, langID))}
          key='featured-content'
          assetID={assetID}
          cycleID={cycleID}
          langID={langID}
          type='featured-content'
          disabled
        />
      )}
    </div>
  )
}

export default AssignedCategories
